import { Currency } from '../types/enums/currency.enum';

export const amountHelper = {
  subscriptionPriceWithIVA,
  subscriptionCurrencyToken,
};

function subscriptionPriceWithIVA(subscriptionBaseCost: number): any {
  return subscriptionBaseCost * 0.22 + subscriptionBaseCost;
}

function subscriptionCurrencyToken(subscriptionCurrency: Currency): string {
  switch (subscriptionCurrency) {
    case Currency.UYU:
      return '$';
    case Currency.USD:
      return 'U$S';
    default:
      return '$';
  }
}
